import * as React from 'react'
import { Card, CardContent, CardHeader, Label, Switch } from '@/shared/ui'
import { useToast } from '@/shared/ui/Toast'
import { getBTCWarningEnabled, setBTCWarningEnabled } from '../services/btcWarningSettingsService'

export default function BTCWarningSettings() {
  const [loading, setLoading] = React.useState(true)
  const [saving, setSaving] = React.useState(false)
  const [enabled, setEnabled] = React.useState(false)
  const { add: toast } = useToast()

  React.useEffect(() => {
    let mounted = true
    getBTCWarningEnabled()
      .then((on) => {
        if (mounted) setEnabled(on)
      })
      .catch((e) =>
        toast({
          title: 'Aviso de correção do Bitcoin',
          description: e?.message || 'Falha ao carregar',
          variant: 'error',
        }),
      )
      .finally(() => {
        if (mounted) setLoading(false)
      })
    return () => {
      mounted = false
    }
  }, [])

  async function handleToggle(next: boolean) {
    if (saving) return
    setSaving(true)
    try {
      await setBTCWarningEnabled(next)
      setEnabled(next)
      toast({
        title: 'Aviso de correção do Bitcoin',
        description: next ? 'Ativado na página de Oportunidades' : 'Oculto na página de Oportunidades',
        variant: 'success',
        soft: true,
      })
    } catch (e: any) {
      toast({
        title: 'Aviso de correção do Bitcoin',
        description: e?.message || 'Falha ao salvar',
        variant: 'error',
      })
    } finally {
      setSaving(false)
    }
  }

  return (
    <Card>
      <CardHeader className="text-base font-semibold">Aviso de correção do Bitcoin (Oportunidades)</CardHeader>
      <CardContent>
        <div className="flex items-center justify-between gap-4">
          <div className="text-sm text-foreground/80">
            Controla a exibição do aviso de correção do Bitcoin no topo da página de Oportunidades. Padrão: desativado.
          </div>
          <div className="flex items-center gap-2">
            <Label>Desativado</Label>
            <Switch
              checked={enabled}
              onChange={(e) => handleToggle((e.target as HTMLInputElement).checked)}
              disabled={loading || saving}
            />
            <Label>Ativado</Label>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

